import { flushSync } from "react-dom";
import { List, ListItemButton } from "@mui/material";
import { useNavContentContext } from "../../NavContent.context";

export default function NavContentNavigation() {
  const { sections, selectedSection, setSelectedSection } = useNavContentContext();

  const handleSectionClick = (section: string) => {
    const next = section.toLowerCase();
    if (next === selectedSection) return;
    if (!document.startViewTransition) {
      setSelectedSection(next);
      return;
    }
    document.startViewTransition(() => {
      flushSync(() => setSelectedSection(next));
    });
  };

  return (
    <List sx={{ p: 0 }} data-test-id="nav-content-navigation">
      {sections.map((section) => (
        <ListItemButton
          key={section}
          selected={selectedSection === section.toLowerCase()}
          onClick={() => handleSectionClick(section)}
          className="capitalize"
        >
          {section}
        </ListItemButton>
      ))}
    </List>
  );
}
